import { Box, Group, Text } from '@mantine/core';
import { toNatural } from '@utils/StringUtils';
import { JobQuestion } from '@th-types/job.detail.type';
import BulletItem from './BulletItem';

interface JobQuestionsProps {
  questions?: JobQuestion[];
}

export default function JobQuestions({ questions }: JobQuestionsProps) {
  if (!questions?.length) {
    return null;
  }

  return (
    <>
      <Text fz={14} fw={700} mt="md" mb="sm">
        Application Questions:
      </Text>
      {questions.map((question) => (
        <Box key={question.id} mt="xs">
          <Group justify="space-between" wrap="nowrap" align="flex-start">
            <BulletItem content={question.text} />
            <Text fz={14} style={{ whiteSpace: 'nowrap' }}>
              <Text span fw={700} inherit>
                Type:{' '}
              </Text>
              {toNatural(question.type)}
            </Text>
          </Group>
          {question.choices?.length > 0 && (
            <>
              <Text fz={14} ml={16}>
                Options:
              </Text>
              {question.choices.map((choice) => (
                <BulletItem
                  key={choice.choice}
                  content={choice.choice}
                  ml={32}
                />
              ))}
            </>
          )}
        </Box>
      ))}
    </>
  );
}
